// Constant Data for Seller

export const SELLER_TYPE = {
  NORMAL    : 'normal',
  EXCLUSIVE : 'exclusive',
  FEATURED  : 'featured',
  DESIGNER  : 'designer',
  SCRAPER   : 'scraper',
  PARTNER   : 'partner'
}


export const SELLER_TYPE_OPTIONS = [
  {
    'label' : 'ALL',
    'value' : ''
  },
  {
    'label' : 'NORMAL',
    'value' : SELLER_TYPE.NORMAL
  },
  {
    'label' : 'FEATURED',
    'value' : SELLER_TYPE.FEATURED
  },
  {
    'label' : 'DESIGNER',
    'value' : SELLER_TYPE.DESIGNER
  },
  {
    'label' : 'EXCLUSIVE',
    'value' : SELLER_TYPE.EXCLUSIVE
  },
  {
    'label' : 'SCRAPER',
    'value' : SELLER_TYPE.SCRAPER
  },
  {
    'label' : 'PARTNER',
    'value' : SELLER_TYPE.PARTNER
  }
]

export const GENDER = {
  FEMALE : 'female',
  MALE   : 'male'
}

export const REFERRER = {
  POI        : 'profession_organiser_indonesia',
  TINKERLUST : 'tinkerlust',
  GOOGLE     : 'google',
  FACEBOOK   : 'facebook',
  INSTAGRAM  : 'instagram',
  TIKTOK     : 'tiktok',
  FRIEND     : 'friend',
  OTHERS     : 'others'
}

export const IS_BANNED_LABEL = {
  true: {
    label : 'Yes',
    value : 'true'
  },
  false: {
    label : 'No',
    value : 'false'
  }
}

export const IS_BANNED = {
  YES : true,
  NO  : false
}

export const BANNED_REASON = {
  SELLING_FAKE_PRODUCTS: 'selling_fake_products'
}

export const SELLER_IDENTITY_TYPES = [
  {
    id    : 'national_identity',
    value : 'national_identity',
    label : 'KTP (Warga Negara Indonesia)'
  },
  {
    id    : 'passport',
    value : 'passport',
    label : 'Paspor (Warga Negara Asing)'
  }
]